// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBag = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M7 7V5a2 2 0 012-2h6a2 2 0 012 2v2h5v14H2V7zm2-2h6v2H9zm7 4H8v10h8zm2 0v10h2V9zM4 9h2v10H4z"
    />
  );
export default SvgIconBag;
